import { useQuery } from '@tanstack/react-query'
import { getDomainIntelligenceArtifactFile } from './domainIntelligenceApi'

// Probe ids repeat across every entity in a group run, so the fetch MUST carry
// the entity id (audit F1: the entity-blind form returns the first matching
// entity's evidence — wrong data under the right heading). The backend resolves
// probes/{entityId}/{probeId}.json against that entity's own dossier and fails
// closed if it is missing. The legacy entity-less path remains only for
// single-entity ad-hoc runs where no entityId exists.
//
// probeOrdinal (audit F1b): the same probe can run in multiple investigation
// passes within one entity, so probeId is not unique even entity-scoped. The
// probe index stamps each row with its 0-based ordinal among same-id records;
// ordinals > 0 address the exact pass via probes/{entityId}/{probeId}@{ordinal}.json
// (ordinal 0 is the backend default, so the suffix is omitted for it).
export const useProbeData = (workspaceID, runPath, probeId, entityId, probeOrdinal) => {
    const ordinal = Number.isInteger(probeOrdinal) && probeOrdinal > 0 ? probeOrdinal : 0
    const probeFile = ordinal > 0 ? `${probeId}@${ordinal}.json` : `${probeId}.json`
    const artifactPath = entityId ? `probes/${entityId}/${probeFile}` : `probes/${probeFile}`

    const {
        data: probeData,
        isLoading: loadingProbeData,
        error: probeDataError,
    } = useQuery({
        queryKey: [
            'domainIntelligenceProbeData',
            workspaceID,
            runPath,
            entityId || null,
            probeId,
            ordinal,
        ],
        queryFn: () => getDomainIntelligenceArtifactFile(workspaceID, runPath, artifactPath),
        enabled: Boolean(workspaceID) && Boolean(runPath) && Boolean(probeId),
    })

    return {
        probeData: probeData?.content || probeData || null,
        loadingProbeData,
        probeDataError,
    }
}
